import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, forkJoin, of } from 'rxjs';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { EnrollmentService } from 'src/app/private/services/enrollment.service';
import { AdmissionService } from 'src/app/private/services/admission.service';
import { StudentService } from 'src/app/private/services/student.service';

@Component({
  selector: 'app-bulk-update',
  imports: [SharedModule],
  templateUrl: './bulk-update.component.html',
  styleUrl: './bulk-update.component.scss'
})
export class BulkUpdateComponent {

  @Output() closeDialog = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  @Input() selectedProducts: any[] = [];
  @Input() courses: any[] = [];
  @Input() title: string = 'Leads';
  @Input() pipelineStages: any[] = [];
  @Input() selectedDefaultPipelineId: number | null = null;

  @Input() isLeads: boolean = false;
  @Input() isRegistration: boolean = false;
  @Input() users: any[] = [];
  @Input() isApplication: boolean = false;
  @Input() isEnrollment: boolean = false;
  @Input() isAdmission: boolean = false;
  @Input() isStudent: boolean = false;
  isSubmitted: boolean = false;
  isFixedColumn: boolean = true;
  isLoading: boolean = false;

  queryTypes: any[] = [
    { label: 'General', value: 'General' },
    { label: 'Admission', value: 'Admission' },
    { label: 'Application', value: 'Application' },
    { label: 'Fee Structure', value: 'Fee Structure' },
    { label: 'Registration', value: 'Registration' },
    { label: 'Placement', value: 'Placement' },
    { label: 'Alumni', value: 'Alumni' },
    { label: 'Course', value: 'Course' },
    { label: 'Other', value: 'Other' }
  ];

  leadSources: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];


  leadTypes: any[] = [
    { label: 'New Lead', value: 'New Lead' },
    { label: 'Cold Lead', value: 'Cold Lead' },
    { label: 'Warm Lead', value: 'Warm Lead' },
    { label: 'Hot Lead', value: 'Hot Lead' }
  ];

  leadStatusList: any[] = [
    { value: 'Assigned', label: 'Assigned' },
    { value: 'Working', label: 'Working' },
    { value: 'Qualified', label: 'Qualified' },
    { value: 'Raw', label: 'Raw' },
    { value: 'Unqualified', label: 'Unqualified' },
  ];

  registrationStatusList: any[] = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Accepted', label: 'Accepted' },
    { value: 'Rejected', label: 'Rejected' }
  ];


  applicationStatusList: any[] = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];


  paymentModeList = [
    { label: 'Cash', value: 'Cash' },
    { label: 'Credit Card', value: 'Credit Card' },
    { label: 'Debit Card', value: 'Debit Card' },
    { label: 'Bank Transfer (NEFT/RTGS/IMPS)', value: 'Bank Transfer' },
    { label: 'Cheque', value: 'Cheque' },
    { label: 'UPI (Google Pay / PhonePe / Paytm)', value: 'UPI' },
    { label: 'Net Banking', value: 'Net Banking' },
    { label: 'Demand Draft', value: 'Demand Draft' },
    { label: 'Wallet', value: 'Wallet' },
    { label: 'Other', value: 'Other' }
  ];

  paymentStatusList = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Failed', value: 'Failed' }
  ];


  modeOfStudyList: any[] = [
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
    { label: 'Hybrid', value: 'Hybrid' }
  ];

  documentStatusList: any[] = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Submitted', value: 'Submitted' },
    { label: 'Verified', value: 'Verified' },
    { label: 'Rejected', value: 'Rejected' }
  ];

  enrollmentStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  // Admission related properties
  @Input() academicYears: any[] = [];
  @Input() departments: any[] = [];
  @Input() feeGroups: any[] = [];
  @Input() scholarships: any[] = [];
  @Input() transportCategories: any[] = [];
  @Input() hostelCategories: any[] = [];
  @Input() scholarshipTypes: any[] = [];
  @Input() batches: any[] = []

  admissionModes: any[] = [
     { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
    { label: 'Hybrid', value: 'Hybrid' }
  ];

  admissionSources: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];

  admissionTypes: any[] = [
    { label: 'Regular', value: 'Regular' },
    { label: 'Transfer', value: 'Transfer' },
    { label: 'Lateral', value: 'Lateral' },
    { label: 'Readmission', value: 'Readmission' },
    { label: 'Dropout', value: 'Dropout' }
  ];

  admissionStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Approved', label: 'Approved' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'Waitlisted', label: 'Waitlisted' }
  ];

  bloodGroups: any[] = [
    { label: 'A+', value: 'A+' },
    { label: 'A-', value: 'A-' },
    { label: 'B+', value: 'B+' },
    { label: 'B-', value: 'B-' },
    { label: 'O+', value: 'O+' },
    { label: 'O-', value: 'O-' },
    { label: 'AB+', value: 'AB+' },
    { label: 'AB-', value: 'AB-' }
  ];

  categories: any[] = [
    { label: 'General', value: 'General' },
    { label: 'SC', value: 'SC' },
    { label: 'ST', value: 'ST' },
    { label: 'OBC', value: 'OBC' },
    { label: 'Other', value: 'Other' }
  ];

  constructor(
    private localStorage: LocalStorageService,
    private api: LeadService,
    private messageService: MessageService,
    private enrollmentService: EnrollmentService,
    private admissionService: AdmissionService,
    private studentService: StudentService
  ) { }

  createFieldFormValue: any = {};

  ngOnChanges(changes: SimpleChanges) {

    this.isSubmitted = false;

    if (changes['users'] && changes['users'].currentValue != changes['users'].previousValue) {
      this.users = this.users.map((user: any) => {
        return {
          label: user.fname + " " + user.lname,
          value: user?.user_id
        }
      }

      );
    }

    // Load pipeline stages when they are received
    if (changes['pipelineStages'] && changes['pipelineStages'].currentValue) {
      if (this.isLeads) {
        this.loadPipelineStages();
      }
    }

    // Also load if selectedDefaultPipelineId changes
    if (changes['selectedDefaultPipelineId'] && changes['selectedDefaultPipelineId'].currentValue) {
      if (this.isLeads && this.pipelineStages && this.pipelineStages.length > 0) {
        this.loadPipelineStages();
      }
    }
  }

  ngOnInit() {

    console.log("isAdmission", this.isAdmission);

    if (this.isEnrollment) {
      // filter out status wiht Moved
      this.selectedProducts = this.selectedProducts.filter(product => product.enrollment_data.enrollment_status !== 'Moved');
    }

    if(this.isAdmission) {
      // filter out status with Converted
      this.selectedProducts = this.selectedProducts.filter(product => product.admission_status !== 'Converted');
    }
  }

  loadPipelineStages() {
    if (this.pipelineStages && this.pipelineStages.length > 0 && this.selectedDefaultPipelineId) {
      // Set the default pipeline ID in the form
      this.createFieldFormValue['pipeline_id'] = this.selectedDefaultPipelineId;
      
      const defaultPipeline = this.pipelineStages.find(p => p.value == this.selectedDefaultPipelineId);
      if (defaultPipeline && defaultPipeline.stages) {
        this.leadStatusList = defaultPipeline.stages.map((stage: any) => ({
          ...stage,
          label: stage.stage_name,
          value: stage.stage_name
        }));
      }
    }
  }

  onPipelineChange(event: any) {
    const selectedPipelineId = event.value;
    if (selectedPipelineId && this.pipelineStages && this.pipelineStages.length > 0) {
      const selectedPipeline = this.pipelineStages.find(p => p.value === selectedPipelineId);
      if (selectedPipeline && selectedPipeline.stages) {
        this.leadStatusList = selectedPipeline.stages.map((stage: any) => ({
          ...stage,
          label: stage.stage_name,
          value: stage.stage_name
        }));
      }
      
      // Reset lead status and score when pipeline changes
      this.createFieldFormValue['lead_status'] = null;
      this.createFieldFormValue['pipeline_score'] = null;
    }
  }

  onStatusChange(event: any) {
    const selectedStatusName = event.value;
    if (selectedStatusName && this.leadStatusList && this.leadStatusList.length > 0) {
      const selectedStage = this.leadStatusList.find((stage: any) => stage.stage_name === selectedStatusName);
      if (selectedStage && (selectedStage.score !== undefined || selectedStage.pipeline_score !== undefined)) {
        this.createFieldFormValue['pipeline_score'] = selectedStage.score || selectedStage.pipeline_score;
      }
    }
  }

  handleCloseDialog() {
    // handle close dialog
    this.closeDialog.emit();
  }

  onSubmit() {
    console.log("onSubmit", this.selectedProducts);
    console.log("payload", this.createFieldFormValue)


    if (this.isStudent) {
      const studentPayload = {
        organization_id: this.localStorage.getOrganizationId(),
        student_ids: this.selectedProducts.map((product: any) => product.student_id),
        academic_year_id: this.createFieldFormValue.academic_year_id,
        batch_id: this.createFieldFormValue.batch_id,
        caste_category: this.createFieldFormValue.caste_category,
        course_id: this.createFieldFormValue.course_id,
        department_id: this.createFieldFormValue.department_id,
        fee_group_id: this.createFieldFormValue.fee_group_id,
        hostel_category: this.createFieldFormValue.hostel_category,
        scholarship_id: this.createFieldFormValue.scholarship_id,
        transport_category: this.createFieldFormValue.transport_category,
        user_id: this.localStorage.getUserId()
      };

      this.isLoading = true;
      this.studentService.updateBulkStudents(studentPayload).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Bulk student update successful' });
          this.reload.emit();
          this.createFieldFormValue = {};
          this.closeDialog.emit();
        },
        error: (error: any) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Bulk student update failed' });
          this.isLoading = false;
          console.log("error", error);
        }
      });
      return;
    }

    if (this.isAdmission) {
      const admissionPayload = {
        organization_id: this.localStorage.getOrganizationId(),
        admission_ids: this.selectedProducts.map((product: any) => product.admission_id),
        lead_ids: this.selectedProducts.map((product: any) => product.lead_id),
        academic_year_id: this.createFieldFormValue.academic_year_id,
        admission_mode: this.createFieldFormValue.admission_mode,
        admission_source: this.createFieldFormValue.admission_source,
        admission_status: this.createFieldFormValue.admission_status,
        admission_type: this.createFieldFormValue.admission_type,
        assigned_to: this.createFieldFormValue.assigned_to,
        approved_by: this.createFieldFormValue.approved_by,
        blood_group: this.createFieldFormValue.blood_group,
        category: this.createFieldFormValue.category,
        department_id: this.createFieldFormValue.department_id,
        hostel_category: this.createFieldFormValue.hostel_category,
        scholarship_id: this.createFieldFormValue.scholarship_id,
        fee_group_id: this.createFieldFormValue.fee_group_id,
        transport_category: this.createFieldFormValue.transport_category,
        course_id: this.createFieldFormValue.preferred_course,
        batch_id: this.createFieldFormValue.batch_id,
        user_id: this.localStorage.getUserId()
      };

      this.isLoading = true;
      this.admissionService.bulkUpdateAdmissions(admissionPayload).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Bulk admission update successful' });
          this.reload.emit();
          this.createFieldFormValue = {};
          this.closeDialog.emit();
        },
        error: (error: any) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Bulk admission update failed' });
          this.isLoading = false;
          console.log("error", error);
        }
      });
      return;
    }

    if (this.isEnrollment) {
      const enrollmentPayload = {
        organization_id: this.localStorage.getOrganizationId(),
        leadIDs: this.selectedProducts.map((product: any) => product.lead_id),
        enrollmentIDs: this.selectedProducts.map((product: any) => product.enrollment_data?.enrollment_id),
        document_status: this.createFieldFormValue.document_status,
        assignee_to: this.createFieldFormValue.assigned_to,
        payment_status: this.createFieldFormValue.payment_status,
        payment_mode: this.createFieldFormValue.payment_mode,
        course_id: this.createFieldFormValue.preferred_course,
        source: this.createFieldFormValue.source,
        enrollment_status: this.createFieldFormValue.enrollment_status,
        mode_of_study: this.createFieldFormValue.mode_of_study,
        user_id: this.localStorage.getUserId()
      };

      this.isLoading = true;
      this.enrollmentService.bulkUpdateEnrollment(enrollmentPayload).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Bulk enrollment update successful' });
          this.reload.emit();
          this.createFieldFormValue = {};
          this.closeDialog.emit();
        },
        error: (error: any) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Bulk enrollment update failed' });
          this.isLoading = false;
          console.log("error", error);
        }
      });
      return;
    }

    const payload: any = {
      organization_id: this.localStorage.getOrganizationId(),
      lead_id: this.selectedProducts.map((product: any) => product.lead_id),
      lead_status: this.createFieldFormValue.lead_status,
      source: this.createFieldFormValue.source,
      lead_type: this.createFieldFormValue.lead_type,
      query_type: this.createFieldFormValue.query_type,
      assigned_to: this.createFieldFormValue.assigned_to,
      old_lead_data: {},
      user_id: this.localStorage.getUserId(),
    };

    // Add pipeline fields only for leads
    if (this.isLeads && !this.isRegistration && !this.isApplication) {
      if (this.createFieldFormValue.pipeline_id && this.createFieldFormValue.pipeline_score) {
        payload.pipeline_id = this.createFieldFormValue.pipeline_id;
      }
      if (this.createFieldFormValue.pipeline_score !== undefined && this.createFieldFormValue.pipeline_score !== null) {
        payload.lead_score = this.createFieldFormValue.pipeline_score;
      }
    }

    if (this.isRegistration) {
      payload.reg_data = {
        "organization_id": this.localStorage.getOrganizationId(),
        "reg_id": this.selectedProducts.map((product: any) => product.registration?.reg_id),
        "status": this.createFieldFormValue.registration_status,
        "preferred_course": this.createFieldFormValue.preferred_course,
      }
    }

    if (this.isApplication) {
      this.isLoading = true;

      const updateApplicationNeeded = this.createFieldFormValue.application_status || this.createFieldFormValue.assigned_to || this.createFieldFormValue.preferred_course;

      const updateLeadNeeded = this.createFieldFormValue.source

      const updateCalls = [];

      const payload2 = {
        organization_id: this.localStorage.getOrganizationId(),
        application_id: this.selectedProducts.map((product: any) => product.application_data?.application_id),
        status: this.createFieldFormValue.application_status,
        assign_to: this.createFieldFormValue.assigned_to,
        course_id: this.createFieldFormValue.preferred_course
      };

      if (updateApplicationNeeded) {
        updateCalls.push(
          this.api.updateApplication(payload2).pipe(
            catchError(error => {
              console.log('Error updating application:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update application.' });
              return of(null); // continue with other requests
            })
          )
        );
      }

      if (updateLeadNeeded) {

        const payload: any = {
          organization_id: this.localStorage.getOrganizationId(),
          lead_id: this.selectedProducts.map((product: any) => product.lead_id),
          source: this.createFieldFormValue.source,
          old_lead_data: {},
          user_id: this.localStorage.getUserId(),
          reg_data: {
            "preferred_course": this.createFieldFormValue.preferred_course,
            "reg_id": this.selectedProducts.map((product: any) => product.registration?.reg_id),
          }
        };

        updateCalls.push(
          this.api.updateBulkLead(payload).pipe(
            catchError(error => {
              console.log('Error updating lead:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update lead.' });
              return of(null);
            })
          )
        );
      }

      if (updateCalls.length > 0) {
        forkJoin(updateCalls).subscribe({
          next: (responses) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Bulk update successful' });
            this.reload.emit();
            this.createFieldFormValue = {};
            this.closeDialog.emit();
          },
          error: (err) => {
            // This shouldn't trigger often since we catch errors inside
            console.log('Unexpected error:', err);
            this.isLoading = false;
            this.isSubmitted = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
          }
        });
      } else {
        this.isLoading = false;
        this.isSubmitted = false;
      }

      return;
    }

    this.isLoading = true;
    this.api.updateBulkLead(payload).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Bulk update successful' });
        this.reload.emit();
        this.createFieldFormValue = {};
        this.closeDialog.emit();
      },
      error: (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Bulk update failed' });
        this.isLoading = false;
        console.log("error", error);
      }
    })

  }

}
